import Home from "@/views/Home.vue";

const ProfileEdit = () => import("@/views/ProfileEdit.vue");
const Admin = () => import("@/views/Admin.vue");
const AdminUserSearch = () => import("@/views/AdminUserSearch.vue");
const AdminUserTable = () => import("@/views/AdminUserTable.vue");
const AdminUserCreate = () => import("@/views/AdminUserCreate.vue");
const AdminPrint = () => import("@/views/AdminPrint.vue");
const AdminReceiptList = () => import("@/views/AdminReceiptList.vue");
const AdminReportList = () => import("@/views/AdminReportList.vue");
const AdminAuthPanel = () => import("@/views/AdminAuthPanel.vue");
const AdminFile = () => import("@/views/AdminFile.vue");
const AdminUpload = () => import("@/views/AdminUpload.vue");
const AdminAccountUpdate = () => import("@/views/AdminAccountUpdate.vue");
const AdminPasswordUpdate = () => import("@/views/AdminPasswordUpdate.vue");
const Report = () => import("@/views/Report.vue");
const ReportSuccess = () => import("@/views/ReportSuccess.vue");
const AdminSuper = () => import("@/views/AdminSuper.vue");

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "user/:id/profile/edit",
        name: "profile-edit",
        component: ProfileEdit
      }
    ]
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: { isAuth: true },
    redirect: { name: "admin-user-table" },
    children: [
      {
        path: "user/table",
        name: "admin-user-table",
        component: AdminUserTable
      },
      {
        path: "user/create",
        name: "admin-user-create",
        component: AdminUserCreate
      },
      {
        path: "user/search",
        name: "admin-user-search",
        component: AdminUserSearch
      },
      {
        path: "print",
        name: "admin-print",
        component: AdminPrint
      },
      {
        path: "reciepts",
        name: "admin-receipt-list",
        component: AdminReceiptList
      },
      {
        path: "reports",
        name: "admin-report-list",
        component: AdminReportList
      },
      {
        path: "shops",
        name: "admin-shops",
        component: () => import("@/views/AdminShops.vue")
      },
      {
        path: "auth",
        name: "admin-auth-panel",
        component: AdminAuthPanel
      },
      {
        path: "upload",
        name: "admin-upload",
        component: AdminUpload
      },
      {
        path: "file/:id?",
        name: "admin-file",
        props: true,
        component: AdminFile
      },
      {
        path: "setting",
        name: "admin-setting",
        component: () => import("@/views/AdminSetting.vue")
      },
      {
        path: "account/update",
        name: "admin-account-update",
        component: AdminAccountUpdate
      },
      {
        path: "password/update",
        name: "admin-password-update",
        component: AdminPasswordUpdate
      },
      {
        path: "cms",
        name: "cms",
        component: () => import("@/views/Cms.vue"),
        children: [
          {
            path: "news",
            name: "cms-news",
            component: () => import("@/views/CmsNews.vue")
          },
          {
            path: "activity",
            name: "cms-activity",
            component: () => import("@/views/CmsActivity.vue")
          },
          {
            path: "calendar",
            name: "cms-calendar",
            component: () => import("@/views/CmsCalendar.vue")
          },
          {
            path: "intro/purpose",
            name: "cms-intro-purpose",
            component: () => import("@/views/CmsPurpose.vue")
          },
          {
            path: "intro/rule",
            name: "cms-intro-rule",
            component: () => import("@/views/CmsRule.vue")
          },
          {
            path: "intro/pastchairman",
            name: "cms-intro-pastchairmans",
            component: () => import("@/views/CmsPastChairmans.vue")
          },
          {
            path: "intro/pastchief",
            name: "cms-intro-pastchiefs",
            component: () => import("@/views/CmsPastChiefs.vue")
          },
          {
            path: "intro/advisors",
            name: "cms-intro-advisors",
            component: () => import("@/views/CmsAdvisors.vue")
          },
          {
            path: "intro/18staffs",
            name: "cms-intro-18staffs",
            component: () => import("@/views/Cms18thStaffs.vue")
          },
          {
            path: "intro/17staffs",
            name: "cms-intro-17staffs",
            component: () => import("@/views/Cms17thStaffs.vue")
          },
          {
            path: "intro/16staffs",
            name: "cms-intro-16staffs",
            component: () => import("@/views/Cms16thStaffs.vue")
          },
          {
            path: "intro/15staffs",
            name: "cms-intro-15staffs",
            component: () => import("@/views/Cms15thStaffs.vue")
          },

          {
            path: "intro/14staffs",
            name: "cms-intro-14staffs",
            component: () => import("@/views/Cms14thStaffs.vue")
          },
          {
            path: "docs/officialdocs",
            name: "cms-officialdocs",
            component: () => import("@/views/CmsOfficialDocs.vue")
          },
          {
            path: "docs/applications",
            name: "cms-applications",
            component: () => import("@/views/CmsApplications.vue")
          }
        ]
      },
      {
        path: "super",
        name: "admin-super",
        component: AdminSuper
      }
    ]
  },
  {
    path: "/report",
    name: "report",
    component: Report
  },
  {
    path: "/report-success",
    name: "report-success",
    component: ReportSuccess
  }
];

export default routes;
